/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsFixAvailableQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsFixAvailableQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsFixAvailableQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsFixAvailableQueryOperator>): AppSecopsFixAvailableQueryOperator {
        let obj = Object.assign(new AppSecopsFixAvailableQueryOperator(), model);
        AppSecopsFixAvailableQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsFixAvailableQueryOperator>): AppSecopsFixAvailableQueryOperator {
        if (!model) return null;
        return AppSecopsFixAvailableQueryOperator.newInstance(<AppSecopsFixAvailableQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsFixAvailableQueryOperator) {
        if (!obj) return;

        models.AppSecopsFixAvailableQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsFixAvailableQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsFixAvailableQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Indicates if the component has a fix available to include
     */
    fix_available: boolean;

}
